// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"b656b488","450":"d91429a8","615":"d91429a8","939":"8ab8626b"}[chunkId] + ".chunk.css";
};